import { type FC } from 'react';

import clsx from 'clsx';

import { BoosterSize, type BoosterType } from '@/shared/ui/booster/booster.types';
import { BoosterIcon } from '@/shared/ui/booster/ui/BoosterIcon';
import { useStickyBannerState } from '@/shared/ui/sticky-banner';
import { Timer } from '@/shared/ui/timer';

import s from './index.module.scss';

interface Props {
  className?: string;
  boosted: number;
  expireTime: string | number | null | undefined;
  boosterType: BoosterType;
  onEnd?: () => void;
}

export const BoosterStickyBanner: FC<Props> = ({
  className,
  boosted,
  expireTime,
  boosterType,
  onEnd,
}) => {
  const bannerState = useStickyBannerState(boosterType);
  const isCollapsed = bannerState?.isCollapsed ?? false;

  return (
    <div className={clsx(s.container, className)}>
      <BoosterIcon
        type={boosterType}
        size={BoosterSize.SMALL}
        className={clsx(s.icon, isCollapsed && s.extra)}
        renderAs="img"
      />
      <div className={clsx(s.content, isCollapsed && s['content-hidden'])}>
        <span className={s.boosted}>×{boosted}</span>
        <Timer
          className={s.time}
          timestamp={expireTime}
          simple
          onEnd={onEnd}
          isPlaycoinStickyBooster={true}
        />
      </div>
    </div>
  );
};
